import * as Yup from "yup";
import { ROLES } from "types/user";

export const initialValues = {
  name: "",
  org_id: "",
  start_ts: "",
  end_ts: "",
  frequency: "",
  should_send_email: false,
  user_ids: [] as string[],
  survey_ids: [] as string[],
};

export const getValidationSchema = () =>
  Yup.object().shape({
    name: Yup.string().nullable(),
    org_id: Yup.string().nullable(),
    start_ts: Yup.string().required("Start date is required"),
    end_ts: Yup.string()
      .required("End date is required")
      .test(
        "is-after-start",
        "End date must be after start date",
        function (value) {
          const { start_ts } = this.parent;
          if (!start_ts || !value) return true;
          return new Date(value) > new Date(start_ts);
        }
      ),
    frequency: Yup.string().required("Frequency is required"),
    should_send_email: Yup.boolean(),
    user_ids: Yup.array().of(Yup.string()),
    survey_ids: Yup.array()
      .of(Yup.string())
      .min(1, "At least one survey is required"),
  });

export const FREQUENCY_OPTIONS = [
  { value: "once", label: "Once" },
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
];
